import ImDfm3dViewer from './ImDfm3dViewer'

export default ImDfm3dViewer
